import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __ } from "../../../../utils";
import { Form, App, Spin } from "antd";
import { CookieGroupModel } from "../../../../models";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../../../store";
import { FormServiceGroup, useFormServiceGroupHandler, useFormServiceGroupProvider } from "@devowl-wp/react-cookie-banner-admin";
import { createCopy } from "@devowl-wp/multilingual";
const CookieGroupEditForm = observer((param)=>{
    let { onClose, edit, navigateAfterCreation = true } = param;
    const { message } = App.useApp();
    const navigate = useNavigate();
    const { cookieStore, optionStore: { others: { defaultCookieGroupTexts: { [(edit == null ? void 0 : edit.data.name) || ""]: defaultDescription } } } } = useStores();
    const data = edit == null ? void 0 : edit.data;
    const { form, defaultValues, isBusy, onFinish, onFinishFailed, onValuesChange, contextValue } = useFormServiceGroupHandler({
        // Currently, we do not provide service group templates, but who knows in future?
        template: defaultDescription ? {
            identifier: "none",
            version: 1,
            name: "",
            description: defaultDescription
        } : undefined,
        handleSave: async (values)=>{
            try {
                if (edit) {
                    edit.setName(values.name);
                    edit.setDescription(values.description);
                    await edit.patch();
                    return ()=>{
                    // Silence is golden.
                    };
                } else {
                    const draft = new CookieGroupModel(cookieStore.groups, {
                        name: values.name,
                        description: values.description,
                        meta: {
                            order: cookieStore.groups.entries.size,
                            isEssential: false,
                            isDefault: false
                        }
                    });
                    await draft.persist();
                    onClose == null ? void 0 : onClose();
                    return ()=>navigateAfterCreation && navigate(`/cookies/${draft.key.toString()}`);
                }
            } catch (e) {
                const { code, ...rest } = e.responseJSON;
                throw [
                    "term_exists",
                    "duplicate_term_slug"
                ].indexOf(code) > -1 ? __("The service group already exists!") : rest.message;
            }
        }
    });
    const initialValues = edit ? {
        name: data.name,
        description: data.description
    } : defaultValues;
    const [FormServiceGroupContextProvider, formServiceGroupContextValue] = useFormServiceGroupProvider({
        ...contextValue,
        recordId: data == null ? void 0 : data.id,
        languages: data == null ? void 0 : data.multilingual,
        languageOnClick: async (recordId, param)=>{
            let { code, id } = param;
            try {
                const forwardId = id === false ? (await createCopy("rcb-cookie-group", recordId, code)).id : id;
                // Open the newly created blocker
                const url = new URL(window.location.href);
                url.hash = `#/cookies/${forwardId}`;
                url.searchParams.set("lang", code);
                window.location.href = url.toString();
            } catch (e) {
                var _e_responseJSON;
                if ((_e_responseJSON = e.responseJSON) == null ? void 0 : _e_responseJSON.message) {
                    message.error(e.responseJSON.message);
                } else {
                    throw e;
                }
            }
        },
        onCancel: onClose
    });
    return /*#__PURE__*/ _jsx(FormServiceGroupContextProvider, {
        value: formServiceGroupContextValue,
        children: /*#__PURE__*/ _jsxs(Spin, {
            spinning: isBusy,
            children: [
                /*#__PURE__*/ _jsx("strong", {
                    children: edit ? __("Edit service group") : __("Add new service group")
                }),
                /*#__PURE__*/ _jsx("hr", {}),
                /*#__PURE__*/ _jsx(Form, {
                    name: "edit-group-form",
                    form: form,
                    style: {
                        width: 300
                    },
                    layout: "vertical",
                    initialValues: initialValues,
                    onFinish: onFinish,
                    onFinishFailed: onFinishFailed,
                    onValuesChange: onValuesChange,
                    labelWrap: true,
                    children: /*#__PURE__*/ _jsx(FormServiceGroup, {})
                })
            ]
        })
    });
});
export { CookieGroupEditForm };
